import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceClassService {

  constructor(private httpClientService: HttpClientService) { }
  async getAllDeviceClass(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeviceClass,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdDeviceClass(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.DeviceClass
    },id);
    return await firstValueFrom(observable);
  }

  async getByNameDeviceClass(name){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.DeviceClass,
      action:"GetByNameDeviceClass",
      queryString:`name=${name}`
    });
    return await firstValueFrom(observable);
  }

  async createDeviceClass(name, status, environmentalConditionId) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.DeviceClass
    }, {
      name: name,
      status: status == "true" ? true : false,
      environmentalConditionId: environmentalConditionId
    });
    return await firstValueFrom(observable);
  }

  async updateDeviceClass(id, name, status, environmentalConditionId) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.DeviceClass
    }, {
      id: id,
      name: name,
      status: status == "true" ? true : false,
      environmentalConditionId: environmentalConditionId
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  event$ = this.eventSubject.asObservable();
  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
